import { createSagas } from "redux-box";
import { call, put, select } from "redux-saga/effects";
import swal from "sweetalert2";
import PronunciationApi from "@s/api/pronunciation";

const errorHandler = err => {
  const msg =
    (err && err.detail) || (err && err.message) || "Something went wrong.";
  swal("Error", msg, "error");
};

// Fetches a page using the filters currently held in the store and commits it.
function* fetchList(offset = 0) {
  const { search, voice_filter } = yield select(
    state => state.pronunciationLexicon
  );
  const res = yield call(PronunciationApi.list, search, voice_filter, offset);
  yield put({
    type: "SET_LIST",
    list: res.result || [],
    count: res.count || 0,
    has_next: res.has_next || false,
    next_page: res.next_page || 0,
    offset,
  });
}

function* loadPage(offset = 0) {
  try {
    yield put({ type: "SET_LOADING", value: true });
    yield* fetchList(offset);
  } catch (err) {
    errorHandler(err);
  } finally {
    yield put({ type: "SET_LOADING", value: false });
  }
}

export default createSagas({
  REQUEST_LIST: function*() {
    yield* loadPage(0);
  },

  REQUEST_LIST_BY_OFFSET: function*({ offset }) {
    yield* loadPage(offset);
  },

  SET_SEARCH: function*() {
    yield* loadPage(0);
  },

  SET_VOICE_FILTER: function*() {
    yield* loadPage(0);
  },

  REQUEST_CREATE: function*({ data }) {
    try {
      yield call(PronunciationApi.create, data);
      swal("Created", "Entry added successfully.", "success");
      yield put({ type: "SET_SELECTED", entry: null });
      yield* fetchList(0);
    } catch (err) {
      errorHandler(err);
    }
  },

  REQUEST_UPDATE: function*({ id, data }) {
    try {
      yield call(PronunciationApi.update, id, data);
      swal("Updated", "Entry updated successfully.", "success");
      yield put({ type: "SET_SELECTED", entry: null });
      yield* fetchList(0);
    } catch (err) {
      errorHandler(err);
    }
  },

  REQUEST_VOICES: function*() {
    try {
      const res = yield call(PronunciationApi.listVoices);
      yield put({ type: "SET_VOICES", voices: res.voices || [] });
    } catch (err) {
      errorHandler(err);
    }
  },

  REQUEST_DELETE: function*({ id }) {
    try {
      const confirm = yield call(() =>
        swal({
          title: "Delete entry?",
          text: "This cannot be undone.",
          type: "warning",
          showCancelButton: true,
          confirmButtonText: "Delete",
        })
      );
      if (!confirm.value) return;
      yield call(PronunciationApi.remove, id);
      swal("Deleted", "Entry removed.", "success");
      const { offset, page_size } = yield select(
        state => state.pronunciationLexicon
      );
      yield* fetchList(offset);
      // Deleting the last row of a page would leave it empty — step back one page.
      const { list } = yield select(state => state.pronunciationLexicon);
      if (list.length === 0 && offset > 0)
        yield* fetchList(Math.max(0, offset - page_size));
    } catch (err) {
      errorHandler(err);
    }
  },
});
